


















import Vue from "vue";

export default Vue.extend({
  name: "InputGroup",

  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    label: {
      type: String,
      required: false
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    modelValue: {
      type: String
    },
    pattern: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: () => {
    return {
      id: ""
    };
  },

  computed: {
    isInputRequired(): boolean {
      return this.isRequired || this.type === "password";
    },

    inputValue: {
      get(): string {
        return this.modelValue;
      },

      set(value): void {
        this.$emit("change", value);
      }
    }
  },

  created(): void {
    this.id = `form-group-${this._uid}`;
  }
});
